import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onSuppliersDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onSuppliersDelete)
    }
  ]

  return (
    <TableSplitButton
      options={options}
      name="supplier"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onSuppliersDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
